import { render, staticRenderFns } from "./ymz_index.vue?vue&type=template&id=abdf88b6&scoped=true"
import script from "./ymz_index.vue?vue&type=script&lang=js"
export * from "./ymz_index.vue?vue&type=script&lang=js"
import style0 from "./ymz_index.vue?vue&type=style&index=0&id=abdf88b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdf88b6",
  null
  
)

export default component.exports